import {AdjustmentMode} from '@/services/auditService/adjustmentModes';

/** adjustmentMode = 4 (ADJUST_AUTO_GEN) 为系统自动调整 */
export function isAutoAdjustmentHeader(adjustmentMode?: number | null): boolean {
    return adjustmentMode === AdjustmentMode.ADJUST_AUTO_GEN;
}

/** 用于 UI 展示：auto header 不展示系统 remark */
export function toDisplayRemark(remark?: string | null, adjustmentMode?: number | null): string {
    if (!remark || isAutoAdjustmentHeader(adjustmentMode)) return '';
    return remark;
}

/** 打开对话框时初始化 remark 输入框 */
export function resolveRemarkForEdit(headerRemark?: string | null, adjustmentMode?: number | null): string {
    if (isAutoAdjustmentHeader(adjustmentMode)) {
        return '';
    }
    if (headerRemark) return headerRemark;
    return 'To reclassify the accounts';
}

/** 保存时：auto header 且用户未填写则保留原 remark（供后端识别） */
export function resolveRemarkForSave(
    userRemark: string,
    originalRemark?: string | null,
    adjustmentMode?: number | null,
): string {
    const trimmed = userRemark.trim();
    if (trimmed) return trimmed;
    if (isAutoAdjustmentHeader(adjustmentMode)) {
        return originalRemark?.trim() || '';
    }
    return trimmed;
}
